<template>
  <div>

    <!-- respondida urlContext -->
    <div :class="getCssResposta()"
      v-if="message.mensagemRespondida && message.tipoMensagemRespondida == TipoMensagem.Link">
      <a :href="message.mensagemRespondida" target="_blank" :title="'Respondeu a mensagem'" class="textoPreto">
        {{ message.mensagemRespondida }}
      </a>
    </div>
    <!-- respondida texto -->
    <div :class="getCssResposta()"
      v-if="message.mensagemRespondida && (message.tipoMensagemRespondida == TipoMensagem.Texto ||message.tipoMensagemRespondida == TipoMensagem.Template )">
      <span :title="'Respondeu a mensagem'">{{ message.mensagemRespondida }}</span>
    </div>
    <!-- respondida audio -->
    <div :class="getCssResposta()"
      v-if="message.mensagemRespondida && message.tipoMensagemRespondida == TipoMensagem.Audio">
      <audio :title="'Respondeu a mensagem'" controls preload="none">
        <source class="m-auto" :src="$store.getters.baseURL + 'arquivo/obter/' + message.mensagemRespondida"
          type="audio/mpeg" />
        {{ $t("textNavegadorNaoSuportaAudio") }}
      </audio>
    </div>
    <!-- respondida video -->
    <div :class="getCssResposta()"
      v-if="message.mensagemRespondida && message.tipoMensagemRespondida == TipoMensagem.Video">
      <video :title="'Respondeu a mensagem'" controls preload="none">
        <source class="m-auto"
          :src="!message.storyArquivoUrl ? $store.getters.baseURL + 'arquivo/obter/' + message.mensagemRespondida : message.storyArquivoUrl"
          type="video/mp4" />
        {{ $t("textNavegadorNaoSuportaVideo") }}
      </video>
    </div>
    <!-- respondida imagem -->
    <div :class="getCssResposta()"
      v-if="message.mensagemRespondida && message.tipoMensagemRespondida == TipoMensagem.Imagem">
      <a :title="'Respondeu a mensagem'" :href="!message.storyArquivoUrl ? $store.getters.baseURL + 'arquivo/obter/' + message.mensagemRespondida : message.storyArquivoUrl
        " target="_blank">
        <img :src="!message.storyArquivoUrl ? $store.getters.baseURL + 'arquivo/obter/' + message.mensagemRespondida : message.storyArquivoUrl
          " />
      </a>
    </div>
    <!-- respondida documento -->
    <div :class="getCssResposta()"
      v-if="message.mensagemRespondida && message.tipoMensagemRespondida == TipoMensagem.Documento">
      <a :title="'Respondeu a mensagem'" :href="$store.getters.baseURL + 'arquivo/obter/' + message.mensagemRespondida"
        target="_blank">
        <span>{{ getMessageContent() }}</span>
        <div class="mt-1">
          <i class="far fa-file-alt fa-2x"></i>
        </div>
      </a>
    </div>
    <div class="message-align-container">
      <div :class="'message' + getOwnerCssClass()">
        <div v-if="message.tipo == TipoMensagem.Texto" :class="getMessageParagraphClass()">
          <div v-html="getMessageContent()"></div>
        </div>

        <div v-if="message.tipo == TipoMensagem.Audio" :class="getMessageParagraphClass()">
          {{ getMessageContent() }}
          <audio controls preload="none" v-if="!message.excluido">
            <source class="m-auto" :src="!message.urlMidia ? $store.getters.baseURL + 'arquivo/obter/' + message.arquivoId : message.urlMidia"
              type="audio/mpeg" />
            {{ $t("textNavegadorNaoSuportaAudio") }}
          </audio>
        </div>

        <div v-if="message.tipo == TipoMensagem.Video" :class="getMessageParagraphClass()">
          <div v-html="getMessageContent()"></div>
          <br><br>
          <video controls preload="none">
            <source class="m-auto"
              :src="!message.urlMidia ? $store.getters.baseURL + 'arquivo/obter/' + message.arquivoId : message.urlMidia"
              type="video/mp4" />
            {{ $t("textNavegadorNaoSuportaVideo") }}
          </video>
        </div>

        <div v-if="message.tipo == TipoMensagem.Documento" class="d-flex flex-row flex-center"
          :class="getMessageParagraphClass()">
          <a v-if="!message.excluido" :href="$store.getters.baseURL + 'arquivo/obter/' + message.arquivoId"
            target="_blank">
            <span>{{ getMessageContent() }}</span>
            <div class="mt-1">
              <i class="far fa-file-alt fa-2x"></i>
            </div>
          </a>
        </div>

        <div v-if="message.tipo == TipoMensagem.Imagem" :class="getMessageParagraphClass()">
          <div v-html="getMessageContent()"></div>
          <div>
            <a class="message--image" :href="!message.urlMidia ? $store.getters.baseURL + 'arquivo/obter/' + message.arquivoId : message.urlMidia
              " target="_blank">
              <img :src="!message.urlMidia ? $store.getters.baseURL + 'arquivo/obter/' + message.arquivoId : message.urlMidia
                " />
            </a>
          </div>
        </div>
        <!-- template -->
        <div v-if="message.tipo == TipoMensagem.Template" :class="getMessageParagraphClass()">
          <strong v-if="message.modeloMensagem.cabecalho == 1">{{ message.modeloMensagem.textoCabecalho }}</strong>
          <div v-if="message.modeloMensagem.cabecalho == 2 && message.modeloMensagem.tipoMidia == 'IMAGE'"
            class="chat-image text-center">
            <a class="message--image" :href="$store.getters.baseURL + 'arquivo/obter/' + message.arquivoId
              " target="_blank">
              <img :src="$store.getters.baseURL + 'arquivo/obter/' + message.arquivoId
                " />
            </a>
          </div>
          <div v-if="message.modeloMensagem.cabecalho == 2 && message.modeloMensagem.tipoMidia == 'VIDEO'"
            class="chat-image text-center">
            <video controls preload="none">
              <source class="m-auto"
                :src="!message.urlMidia ? $store.getters.baseURL + 'arquivo/obter/' + message.arquivoId : message.urlMidia"
                type="video/mp4" />
              {{ $t("textNavegadorNaoSuportaVideo") }}
            </video>
          </div>
          <div v-html="getMessageContent()"></div>
          <div>
            <p class="chat-bubble-footer">{{ message.modeloMensagem.rodape }}</p>
          </div>
          <div v-for="selectedItem in message.modeloMensagem.botoes" :key="selectedItem.id" class="text-center "
            style="color: rgb(0, 132, 255)">
            <div class="botoesPrevia" v-if="selectedItem.id === 'QUICK_REPLY'">
              <button :disabled="message.origem == 2" class="btn btn-info"><i class="fas fa-reply"></i> {{ selectedItem.textoBotao }}</button>
            </div>
            <div class="botoesPrevia" v-if="selectedItem.id === 'PHONE_NUMBER'">
              <button :disabled="message.origem == 2" class="btn btn-info"><i class="fas fa-phone-alt"></i> {{ selectedItem.textoBotao }}</button>
            </div>
            <div class="botoesPrevia" v-if="selectedItem.id === 'URL'">
              <button :disabled="message.origem == 2" class="btn btn-info"><i class="fas fa-external-link-alt"></i> {{ selectedItem.textoBotao }}</button>
            </div>
          </div>
        </div>
        <!-- fim template -->
        <div v-if="message.tipo == TipoMensagem.Log ||
          message.tipo == TipoMensagem.Interna
          " :class="getMessageParagraphClass()">
          {{ getMessageContent() }}
        </div>

        <div v-if="message.tipo == TipoMensagem.Localizacao" :class="getMessageParagraphClass()">
          <a class="d-flex flex-column" :href="'https://maps.google.com/maps?q=' +
            message.latitude +
            ' ' +
            message.longitude
            " target="_blank">
            <div>
              <i class="fas fa-map icon-size"></i>
              <i class="fas fa-map-marker-alt m-1 icon-size--small-1" aria-hidden="true"></i>
              <div>
                <span class="font-weight-bold">Google</span>
                <span>Maps</span>
              </div>
            </div>
          </a>
        </div>
        <div v-if="message.origem == OrigemMensagem.Enviada" class="ml-2 mr-2" :title="getTitleStatus()">
          <i :class="getIconStatus()"></i>
        </div>

        <MessageAction refs="messageAction" :controller="actionsController" :message="message"
          @onDeleteMessage="onDeleteMessage" @replyMessageAction="replyMessageAction"
          @reactMessageAction="reactMessageAction"></MessageAction>
      </div>
      <div v-if="reagirMsg" id="EmojiButton"></div>
    </div>
    <div :class="getCssReacao()" v-if="message.ultimaReacao">
      <span :title="'Reagiu a sua mensagem'">{{ message.ultimaReacao }}</span>
    </div>
  </div>
</template>

<script>
import OrigemMensagem from "../../enums/OrigemMensagem";
import TipoMensagem from "../../enums/TipoMensagem";
import StatusMensagem from "../../enums/StatusMensagem";
import MessageAction from "./MessageAction";
import EmojiButton from "@joeattardi/emoji-button";

const myMessageClass = " message--my";
const otherMessageClass = " message--other";
const messageIndicatorClass = " message--indicator";
const messageDeletedTextClass = " message--deleted-text ";
const messageScheduledClass = " message--scheduled";
const messageDeletedClass = " message--deleted";
const messageTextClass = "message--text textoPreto";

export default {
  name: "Message",
  components: {
    MessageAction
  },
  props: {
    message: {
      type: Object,
      default: Object
    }
  },
  data() {
    return {
      //messageOwnerClass: "",
      //messageParagraphClass: "",
      //messageDeleted: "",
      deleted: false,
      reagirMsg: false,
      actionsController: {
        showMainMenuButton: true,
        showActions: false,
        enableDelete: true,
        enableEncaminhar: true,
        enableResponder: true,
        enableReagir: true
      }
    };
  },
  computed: {
    TipoMensagem() {
      return TipoMensagem;
    },
    OrigemMensagem() {
      return OrigemMensagem;
    }
  },
  // created() {
  //this.buildMessage();
  // },
  // updated() {
  //this.buildMessage();
  // },
  methods: {
    getTitleStatus() {
      switch (this.message.status) {
        case StatusMensagem.NaoEnviada:
          return this.$t("statusMessages.notSend");
        case StatusMensagem.Enviando:
          return this.$t("statusMessages.sending");
        case StatusMensagem.Enviada:
          return this.$t("statusMessages.sent");
        case StatusMensagem.RecebidaLida:
          return this.$t("statusMessages.receivedMessageRead");
        case StatusMensagem.RecebidaNaoLida:
          return this.$t("statusMessages.receivedUnreadMessage");
        default:
          return "";
      }
    },
    getIconStatus() {
      switch (this.message.status) {
        case StatusMensagem.NaoEnviada:
        case StatusMensagem.Enviando:
          return "far fa-clock fa-xs message-env";
        case StatusMensagem.Enviada:
          return "fas fa-check fa-xs message-env";
        case StatusMensagem.RecebidaNaoLida:
          return "fas fa-check-double fa-xs message-env";
        case StatusMensagem.RecebidaLida:
          return "fas fa-check-double fa-xs message-read";
        default:
          return "";
      }
    },
    buildMessage() {
      this.setOwnerCssClass();
    },
    getOwnerCssClass() {
      let messageBuilder = "";
      let showMainMenuButton = false;
      if (this.message.origem == OrigemMensagem.Recebida) {
        messageBuilder =
          "" + otherMessageClass + messageIndicatorClass + " mr-auto";
        this.actionsController.enableDelete = false;
        showMainMenuButton = true;
      }

      if (this.message.origem == OrigemMensagem.Enviada) {
        messageBuilder =
          "" + myMessageClass + messageIndicatorClass + " ml-auto";
        showMainMenuButton = true;
      }

      if (this.message.tipo == TipoMensagem.Log) {
        this.actionsController.enableDelete = false;
        messageBuilder = " message--log";
      }

      if (this.message.tipo == TipoMensagem.Interna) {
        this.actionsController.enableDelete = false;
        messageBuilder = " message--internal" + " ml-auto";
      }

      if (this.message.isAgendado) {
        messageBuilder += messageScheduledClass;
      }

      if (this.message.excluido || this.showMainMenuButton) {
        this.actionsController.enableDelete = false;
        messageBuilder += messageDeletedClass;
        //this.messageParagraphClass += "" + messageDeletedTextClass;
      }

      if (this.message.contato.enumTipoContato != 0) {

        this.actionsController.enableEncaminhar = false;
        this.actionsController.enableDelete = false;
        this.actionsController.enableReagir = false;
        this.actionsController.enableResponder = false;
      }

      //this.messageParagraphClass += "" + messageTextClass;
      //this.messageOwnerClass = "" + messageBuilder;
      this.actionsController.showMainMenuButton = showMainMenuButton;
      return "" + messageBuilder;
    },
    getCssReacao() {
      if (this.message.origem == OrigemMensagem.Recebida)
        return 'balaoRecebida'
      else
        return 'balao'
    },
    getMessageParagraphClass() {
      let messageParagraphClass = "";

      if (this.message.excluido || this.showMainMenuButton) {
        messageParagraphClass += "" + messageDeletedTextClass;
      }
      return (messageParagraphClass += "" + messageTextClass);
    },
    getMessageContent() {
      switch (this.message.tipo) {
        case TipoMensagem.Audio:
          return "";
        case TipoMensagem.Localizacao:
        case TipoMensagem.Video:
          return this.message.corpo ? this.message.corpo.replace(/\*(.*?)\*/g, '<b>$1</b>') : "";
        default:
          const formattedText = this.message.corpo ? this.message.corpo.replace(/\*(.*?)\*/g, '<b>$1</b>') : this.message.corpo;
          return formattedText;
      }
    },
    onDeleteMessage() {
      this.deleted = true;
    },
    getCssReacao() {
      if (this.message.origem == OrigemMensagem.Recebida)
        return 'balaoRecebida'
      else
        return 'balao'
    },
    getCssResposta() {
      if (this.message.origem == OrigemMensagem.Recebida)
        return 'balaoResposta'
      else
        return 'balaoRespostaEnviada'
    },
    reactMessageAction() {
      this.reagirMsg = true;
      const button = document.querySelector("#EmojiButton");
      const picker = new EmojiButton({ position: 'top-start', theme: 'dark', showSearch: false });
      picker.on("emoji", (emoji) => {
        this.EnviaReacaoApi(emoji)
      });
      picker.togglePicker(button);
    },
    replyMessageAction() {
      this.$emit("replyMessageAction", this.message)
    },
    EnviaReacaoApi(reacao) {

      var viewModel = {
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        mensagemId: this.message.id,
        ultimaReacao: reacao
      }
      console.log("vm ", viewModel)
      this.$http({
        url: "mensagem-front/reacao",
        data: viewModel,
        method: "POST"
      })
        .then((resposta) => {

        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          })
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.message-read {
  color: blue;
}

.message-env {
  color: #969696;
}

.balao {
  position: relative;
  display: inline-block;
  padding: 5px;
  background-color: #dcf8c6;
  border-radius: 15px;
  left: 98%;
  margin-top: -2%;
}

.balaoRecebida {
  position: relative;
  display: inline-block;
  padding: 5px;
  background-color: #dcf8c6;
  border-radius: 15px;
  margin-top: -2%;
}

.balaoResposta {
  position: relative;
  display: inline-block;
  padding: 8px;
  background-color: #128C7E;
  border-radius: 15px;
  color: #01201d;
  max-width: 100%;

}

.balaoRespostaEnviada {
  position: relative;
  display: inline-block;
  padding: 8px;
  background-color: #128C7E;
  border-radius: 15px;
  color: #01201d;
  max-width: 100%;
  left: 100%;
  transform: translateX(-100%);
  text-align: right;
}

.balaoRespostaEnviada img {
  width: 100%;
  /* Defina a largura desejada */
  max-width: 100%;
  height: auto;
  /* Mantenha a proporção da imagem */
  margin: auto auto auto auto;
  max-width: 4rem;
  max-height: 10rem;
  border-radius: 2px;
}

.balaoResposta img {
  width: 100%;
  /* Defina a largura desejada */
  max-width: 100%;
  height: auto;
  /* Mantenha a proporção da imagem */
  margin: auto auto auto auto;
  max-width: 4rem;
  max-height: 10rem;
  border-radius: 2px;
}

.textoPreto {
  color: black;
}

.chat-bubble-footer {
  margin: 0;
  font-size: 12px;
  color: #929292;
  word-wrap: break-word;
}
.botoesPrevia {
    border-top: 1px solid #929292;
    border-bottom: 1px solid #929292;
    padding: 8px 0;
    text-align: center;
}
</style>
